import React from "react";
import ConditionsBlock from "../../components/ConditionsBlock/ConditionsBlock";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import {useNavigate} from "react-router-dom";
import styles from "./unsubscription.module.css";
import {ReactComponent as UnsubscriptionLogo} from './img-unsubscription/logo.svg';

const UnsubscriptionSuccess = () => {
  const navigate = useNavigate();


  const redirectToSpecifiedTerm = (e) => {
    if (!e.target) return;

    navigate(RoutesToPages.terms, {
      state: e.currentTarget.dataset.terms
    });
  }


  return (
    <div className={styles.container}>
      <div className={styles.containerContent}>
        <UnsubscriptionLogo className={styles.logo}
                            width='280'
                            height='188'/>
        <p className={styles.descriptionsInfo}>Vaše predplatné bolo zrušené.</p>
        <p className={styles.descriptionsInfo}>Na váš mobilný telefón obdržíte potvrdenie SMS.</p>
        <p className={styles.descriptionsInfoSuccess}>Nezabudnite, že môžete naďalej používať službu počas obdobia
          predplatného, ktoré už bolo zaplatené.</p>
        <button className={styles.unsubscriptionBtn}
                onClick={() => navigate(RoutesToPages.mainPage)}>
          Pokračovať
        </button>
        <p className={styles.descriptionsInfo}>Naše zákaznícke služby sú tu tiež pre vás!</p>
        <p className={styles.descriptionsInfo}>Email: propulse.sk@silverlines.info</p>
        <p className={styles.descriptionsInfo}>Telefón: +421 313215999</p>
      </div>

      <div className={styles.containerFooter}>
        <ConditionsBlock handleRedirectToTerm={redirectToSpecifiedTerm}/>
      </div>
    </div>
  );
};


export default UnsubscriptionSuccess;